import { render, staticRenderFns } from "./ConsultantAccept.vue?vue&type=template&id=725234ea&"
import script from "./ConsultantAccept.vue?vue&type=script&lang=js&"
export * from "./ConsultantAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports